module.exports = __webpack_public_path__ + "static/media/Inter-Regular.d55e9576.woff2";